/*jslint browser */
/*global process */

import AccessoriesController from "./controller/accessories.controller";
import AttributesController from "./controller/attributes.controller";
import CartController from "./controller/cart.controller";
import ProductGridController from "./controller/product.grid.controller";
import QuantityChangerController from "./controller/quantity.changer.controller";
import ProductStorageController from "./controller/product.storage.controller";
import ConfiguratorController from "./controller/configurator.controller";

declare var settings: any;

/*const globalAny:any = global;
globalAny.$ = jQuery;*/

(function ($, global) {
    "use strict";

    const init = function () {
        console.log('xt-front: ready!');

        routing();
    }

    const routing = function () {
        const app = $('#xt-app').attr('data-app');
        console.log(app);

        new ProductGridController().gridAction();
        new QuantityChangerController().quantityChangerAction();
        new ProductStorageController().storageAction();
        new CartController().cartAction();
        switch (app) {
            case 'accessory': new AccessoriesController(settings).accesoriesAction();
                                new AttributesController(settings).attributesAction();
                                new ConfiguratorController(settings).configuratorAction();
                                //new ProductGridController().gridAction();
                break;
            case 'storage': new AccessoriesController(settings).accesoriesAction();
                            new AttributesController(settings).attributesAction();
                            new ConfiguratorController(settings).configuratorAction();
                            //new ProductGridController().gridAction();
                break;
            case 'cart': new AccessoriesController(settings).accesoriesAction();
                        new AttributesController(settings).attributesAction();
                        new ConfiguratorController(settings).configuratorAction();
                        //new ProductGridController().gridAction();
                break;
            /*case 'grid': new ProductGridController().gridAction();
                break;*/
        }
    }

    $(function () {
        init();
    });
})(jQuery, this)
